import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { trackEvent } from 'dibs-tracking';
import LogoIcon from 'dibs-icons/exports/Logo';
import LogoTradeIcon from 'dibs-icons/exports/LogoTrade';
import styles from './Logo-style.scss';

const trackingObj = {
    category: 'navigation',
    action: 'header navigation click',
    label: 'home link|1stdibs logo',
};

const Logo = ({ isUserTypeTrade, isUserTypeVip }) => {
    return (
        <div className={styles.wrapper}>
            <a
                href="/"
                className={styles.iconWrapper}
                onClick={() => {
                    trackEvent(trackingObj);
                }}
            >
                {isUserTypeTrade ? (
                    <LogoTradeIcon />
                ) : (
                    <LogoIcon className={styles.nonTradeIconHeightFix} />
                )}
                {/* We do not want this INTL'd to preserve text proportions */}
                {!isUserTypeTrade && isUserTypeVip && (
                    <div className={styles.vipText}>PRIVATE CLIENT</div>
                )}
            </a>
        </div>
    );
};

Logo.propTypes = {
    isUserTypeTrade: PropTypes.bool,
    isUserTypeVip: PropTypes.bool,
};

const mapStateToProps = state => {
    const { isUserTypeTrade, isUserTypeVip } = state.header;

    return {
        isUserTypeTrade,
        isUserTypeVip,
    };
};

export default connect(mapStateToProps)(Logo);
